export const replaceStringUsingJSON = (obj: any, searchString: string, replaceString: string) => JSON.parse(JSON.stringify(obj).replace(new RegExp(searchString, 'g'), replaceString));
